module.exports = __webpack_public_path__ + "img/logo-shape-only.e265bed2.svg";